import type { ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'

interface BigCardProps {
  children: ReactNode
  className?: string
}

const BigCard = ({ children, className }: BigCardProps) => {
  return <div className={twMerge('bg-body p-3 rounded-2xl w-full h-full', className)}>{children}</div>
}

export default BigCard
